import React from 'react';
import { RangeGrowth, WhereUsers, FIUsers } from '../components.js';

class UsersMain extends React.Component {


	constructor(props) {
		super(props);

		this.whereSubviewClick = this.whereSubviewClick.bind(this);
		this.fiSubviewClick = this.fiSubviewClick.bind(this);
	}

	whereSubviewClick(e) {
		if(this.props.whereSubviewClick) this.props.whereSubviewClick(e);
	}

	fiSubviewClick(e) {
		if(this.props.fiSubviewClick) this.props.fiSubviewClick(e);
	}

	render () {
		const arContainerSize = {
		    width : '62vmin',
		    height: 'auto'
		  };

		const whereContainerSize = {
		  	width : '38vmin',
		  	height: 'auto'
		};

		const fiContainerSize = {
			width: '38vmin',
			height: 'auto'
		};

	  	return (
	  		<div className="App-HomeBoxes">
	            <div className="App-ChartsBoxRow1">
	              	<RangeGrowth size={arContainerSize} />
	              	<div className='App-ChartsBoxCol1'>
	              		<WhereUsers zip={this.props.zip} heatmap={''} size={whereContainerSize} subview={true} subviewClick={this.whereSubviewClick} />
	            		<FIUsers size={fiContainerSize} subviewClick={this.fiSubviewClick} />
	            	</div>
	            </div>
	         </div>
	  	);
	}
}




export default UsersMain;

